import { useEffect, useState } from 'react';
import { get } from 'lodash';
import { Controller, useForm } from 'react-hook-form';
import InputField from '../../Common/InputField';
import CheckboxField from '../../Common/CheckboxField';
import UploadField from '../../Common/UploadField';
import { Grid, Button } from '@mui/material';
import TicketCharter from '../Ticket-Notes/TicketCharter';
import DateField from '../../Common/DateField';
import BackButton from '../../Common/BackButton';

import {
  postRequest,
  putRequest,
  getRequest,
} from '../interceptor/interceptor';
import FullScreenLoader from '../Loader/FullScreenLoader';
import {
  UPDATE_BUDGET_NEWS,
  ADD_BUDGET_NEWS,
  UNIQUE_ID,
  DOCUMENT_UPLOAD,
} from '../../apiConst';
import { useLocation, useNavigate } from 'react-router';
import SelectDropdown from '../../Common/SelectDropdown';
import CkEditorComponent from '../../Common/CkEditor';
import moment from 'moment';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { videoFields } from '../../Fields/videoFields';

const AddVideo = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const fields = [...videoFields];
  const [id, setId] = useState(null);
  const [videoId, setVideoId] = useState(
    location?.state?.data?.task?.videoId || null
  );
  const [isEdit, setIsEdit] = useState(null);

  const [isTicketToggle, setIsTicketToggle] = useState(true); // State to toggle the accordion
  const [photo, setPhoto] = useState('');
  const ticketToggleAccordion = () => {
    setIsTicketToggle(!isTicketToggle);
  };

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues,
    control,
    formState: { errors },
  } = useForm({});

  useEffect(() => {
    if (location?.state?.isEdit || location?.state?.isView) {
      location?.state?.isEdit && setIsEdit(location?.state?.isEdit);
      const { task } = location?.state?.data;
      console.log('task', task);
      // Set form fields using setValue
      fields.map((field) => setValue(field.fieldName, task[field.fieldName]));
      setPhoto(task?.photo);
    } else {
      // If neither edit nor view, generate unique ID or perform other logic
      getUniqueId();
    }
  }, []);

  const onCancel = () => {
    navigate('/videos', {});
  };
  const getUniqueId = () => {
    setIsLoading(true);
    getRequest(`${UNIQUE_ID}${'VID'}`)
      .then((res) => {
        console.log('res', res);
        const { data } = res;
        if (data) {
          setValue('videoId', data);
          setVideoId(data);
          setIsLoading(false);
        } else {
          setIsLoading(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const onSubmit = (data, e) => {
    console.log('e', e.target.value);
    console.log('data in news', data);
    let url = '';
    setIsLoading(true);
    const payload = {
      videoId: data?.videoId,
      videoTitle: data?.videoTitle,
      videoLink: data?.videoLink,
      module: 'news',
      type: 'video',
      videoType: data?.videoType,
      photo: photo,
    };

    if (isEdit) {
      url = putRequest(`${UPDATE_BUDGET_NEWS}`, payload);
    } else {
      url = postRequest(`${ADD_BUDGET_NEWS}`, payload);
    }
    url
      .then((res) => {
        console.log('res', res);
        toast.info(res);
        setIsLoading(false);
        navigate('/videos');
      })
      .catch(() => {
        setIsLoading(false);
      });
    setIsLoading(false);
  };
  const onUpload = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const file = e.target.files[0];
    const formData = new FormData();

    formData.append('file', file);
    formData.append('isPublic', true);
    setValue('uploadFile', '');
    setValue('uploadFileName', '');

    postRequest(`${DOCUMENT_UPLOAD}`, formData, {
      'Content-Type': 'multipart/form-data',
    })
      .then((res) => {
        const { url, fileName } = res.data.data[0];
        setValue('uploadFile', url);
        setValue('uploadFileName', fileName);
        setPhoto(url);
        setTimeout(() => {
          setIsLoading(false);
        }, 100);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  const onRemoveFile = (e) => {
    setValue('uploadFile', '');
    setValue('uploadFileName', '');
    setPhoto('');
  };
  return (
    <>
      {isLoading && <FullScreenLoader />}
      <div className="block rounded-lg bg-white p-6 shadow-[0_2px_15px_-3px_rgba(0,0,0,0.07),0_10px_20px_-2px_rgba(0,0,0,0.04)] m-4 overflow-auto">
        <BackButton onClick={() => navigate(-1)} />
        <div className="flex mb-2 text-xl font-extrabold text-gray-700">
          {isEdit ? 'Edit' : location?.state?.isView ? 'View' : 'Add'} Video
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div
                className="flex justify-between items-center text-white rounded-md bg-gray-700 p-2 mb-1 cursor-pointer"
                onClick={ticketToggleAccordion} // Toggle on click
              >
                <h2>Video Details</h2>
                {/* Render the icon based on the toggle state */}
                {isTicketToggle ? <FaChevronUp /> : <FaChevronDown />}
              </div>
            </Grid>
            {isTicketToggle &&
              videoFields?.map((field) => {
                const {
                  fieldTitle,
                  fieldName,
                  fieldType,
                  validationObj,
                  options,
                } = field;

                return (
                  <>
                    <Grid
                      item
                      xs={12}
                      lg={
                        fieldType === 'textarea'
                          ? 12
                          : fieldName === 'newsId'
                          ? 2
                          : fieldName === 'type'
                          ? 2
                          : 4
                      }
                      key={fieldName}
                    >
                      {fieldType === 'upload' ? (
                        <div className="">
                          <label className="block text-gray-800 text-sm font-bold mb-3 pr-4">
                            {fieldTitle}
                          </label>
                          <UploadField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            errors={errors}
                            fieldType={fieldType}
                            onChange={onUpload}
                            onRemoveFile={onRemoveFile}
                            accept="image/*"
                            valueClassName={'flex m-2 items-center'}
                            // value={
                            //   getValues('uploadFileName') !== ''
                            //     ? getValues('uploadFileName')
                            //     : ''
                            // }
                            // onBlur={onFieldBlur}
                            placeholder={fieldTitle}
                          />
                        </div>
                      ) : fieldType === 'select' ? (
                        <>
                          <label className="block text-sm text-gray-800 font-bold mb-3 pr-4">
                            {fieldTitle}
                          </label>
                          <SelectDropdown
                            fieldName={fieldName}
                            options={options}
                            register={register}
                            validationObj={validationObj}
                            errors={errors}
                            val={getValues(fieldName)}
                          />
                        </>
                      ) : (
                        <>
                          <label className="block text-gray-800 text-sm font-bold mb-3 pr-4">
                            {fieldTitle}
                          </label>
                          <InputField
                            fieldName={fieldName}
                            validationObj={validationObj}
                            register={register}
                            disabled={
                              fieldName === 'videoId'
                                ? true
                                : location?.state?.isView
                            }
                            errors={errors}
                            fieldType={fieldType}
                          />
                        </>
                      )}
                    </Grid>
                  </>
                );
              })}
            {photo !== '' && (
              <div className="mt-4">
                <img
                  src={photo}
                  alt="Uploaded file preview"
                  className="w-32 h-32 object-cover rounded-md border border-gray-300"
                />
                <Button
                  variant="contained"
                  color="error"
                  className="mt-2"
                  onClick={onRemoveFile}
                >
                  Remove Image
                </Button>
              </div>
            )}
          </Grid>
          {/* <TicketCharter
            taskId={id}
            ticketNo={videoId}
            isView={location?.state?.isView}
            noteStatus="inprogress"
          /> */}

          <div className="flex flex-row items-center justify-center space-x-4">
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={onCancel}
                className="mt-5"
              >
                {location?.state?.isView ? 'Back' : 'Cancel'}
              </Button>
            </Grid>
            {/* <Grid item>
              <Button
                variant="contained"
                color="secondary"
                type="submit"
                className="mt-5"
                disabled={location?.state?.isView}
                value="save"
                onClick={handleSubmit(onSubmit)}
              >
                Save
              </Button>
            </Grid> */}
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className="mt-5"
                disabled={location?.state?.isView}
                value="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {isEdit ? 'Update' : 'Submit'}
              </Button>
            </Grid>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddVideo;
